import { MUST_OUT, MUST_IN, ON_ERROR } from '../types/AuthenticationTypes';

const initialState = {
  userAuth: '',
};

const authenticationReducer = (state = initialState, action) => {
  switch (action.type) {
    case MUST_OUT:
      return { ...state, userAuth: 'must_out' };
    case MUST_IN:
      return { ...state, userAuth: 'must_in' };
    case ON_ERROR:
      return { ...state, userAuth: 'on_error' };
    default:
      return state;
  }
};

export default authenticationReducer;
